<template>
    <v-sheet class="ma-0 py-4 pl-4 pr-3" rounded="lg">
        <v-row class="pa-0 align-center" no-gutters>
            <span class="font-weight-medium fontOneToTwo">야간점검일지</span>
            <v-spacer></v-spacer>
            <v-btn
                @click="$emit('offMdl', true)"
                style="margin-top: 2px;" icon>
                <v-icon class="grey006--text" size="30">mdi-close</v-icon>
            </v-btn>
        </v-row>
        <v-row class="pa-0 align-center mx-1 mt-2" no-gutters>
            <span class=" fontDotEight">야간시간 22:00 ~ 06:00</span>
        </v-row>
        <v-divider class="mt-2"></v-divider>
        <v-row class="greyE01 pa-0" no-gutters>
            <v-col class="txtAlgnMid py-1" cols="12">
                <span class="font-weight-medium">점검일 {{ bscsInfo.insDtDot }} ({{ bscsInfo.inspDay }})</span>
            </v-col>
        </v-row>
        <v-divider class=""></v-divider>
        <v-row class="greyE01 pa-0" no-gutters>
            <v-col class="txtAlgnMid tableBR py-1" cols="4">
                <span class="font-weight-medium">점검구역</span>
            </v-col>
            <v-col class="txtAlgnMid py-1" cols="8">
                <span class="font-weight-medium">점검시간</span>
            </v-col>
        </v-row>
        <v-divider class=""></v-divider>
        <div
            v-if="inspRecDtlList.length > 0"
            class="d-inline-block overflow-y-auto"
            :style="{ 'width': '100%', 'height': ($vuetify.breakpoint.height - 270) + 'px' }">
            <v-row
                class="pa-0 tableBB"
                v-for="(lst, i) in inspRecDtlList" :key="i"
                no-gutters>
                <v-col class="txtAlgnMid tableBR px-1" style="padding-top: 12px; line-height: 1;" cols="4">
                    <span class="fontDotEight">{{ lst.inspAreaNm }}</span>
                </v-col>
                <v-col class="pt-1 pl-1 txtAlgnMid" cols="8">
                    <v-row class="pa-0 align-start" no-gutters>
                        <v-col
                            v-for="(inspInf, j) in lst.inspReclist" :key="j"
                            cols="4">
                            <v-btn
                                :class="[inspInf.inspTm != '' ? 'blue001 white--text' : '']"
                                min-width="47" max-width="53" height="36" :ripple="false"
                                style="padding: 0px 8px 0px 8px; margin-bottom: 2px;"
                                @click="$parent.$parent.$parent.$parent.onInspDtlMdl(inspInf.inspAreaPk, inspInf.inspOrd)"
                                small outlined>
                                <span v-if="inspInf.inspTm == ''" class="fontDotSeven">미작성</span>
                                <span v-else class="fontDotSeven" style="line-height: 1.1;">
                                    {{ inspInf.rn }}회차 <br> {{ inspInf.inspTm }}
                                </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <v-row v-else class="pa-0 tableBB" no-gutters>
            <v-col class="txtAlgnMid pa-2" cols="12">
                <span class="fontDotEight">※ 조회된 목록이 없습니다.</span>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

export default {
    name: 'NtyInspAreaMdl',

    props : {
        sltYMD: { type: String, default: '' }
    },
            
    components: {
      
    },

    created: function(){
  
    },
    
    mounted: function(){
        //돔 로딩이 끝난 후 작업
        this.$nextTick(function () {
            this.rflInspDt()
        })
    },

    computed: {

    },

    watch:{
        'sltYMD': function () {
            this.rflInspDt()
        },
    },

    methods: { 
        // 구역별 일일 야간점검일지 조회
        getInspRecDtl: function (ymd){
            this.inspRecDtlList.splice(0)

            let obj = {}
            obj.inqYMD = ymd
       
            http.post('empApp/selInspRecDtlSttlist', obj)
                .then((response) => ( this.inspRecDtlRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selInspRecDtlSttlist : ' + error))
        },

        inspRecDtlRst: function (res) {
            if(res.statusCode == 200){
                res.data.forEach(idx => {
                    idx.inspReclist.forEach(itm => {
                        if(itm.inspTmHh != '' && itm.inspTmMm != '')
                            itm.inspTm = itm.inspTmHh + ':' + itm.inspTmMm
                        else
                            itm.inspTm = ''
                    });
                });

                this.inspRecDtlList = res.data
            }
        },

        rflInspDt: function () {
            if(this.sltYMD != ''){
                let chc = this.$moment(this.sltYMD, 'YYYYMMDD')
                let dday = chc.day() // 0(일) ~ 6(토)
                this.bscsInfo.insDtDot = chc.format('YYYY.MM.DD')

                switch (dday) {
                    case 0:
                        this.bscsInfo.inspDay = '일요일'
                        break;
                    case 1:
                        this.bscsInfo.inspDay = '월요일'
                        break;
                    case 2:
                        this.bscsInfo.inspDay = '화요일'
                        break;
                    case 3:
                        this.bscsInfo.inspDay = '수요일'
                        break;
                    case 4:
                        this.bscsInfo.inspDay = '목요일'
                        break;
                    case 5:
                        this.bscsInfo.inspDay = '금요일'
                        break;
                    case 6:
                        this.bscsInfo.inspDay = '토요일'
                        break;
                    default:
                        break;
                }

                this.getInspRecDtl(this.sltYMD)
            }
        },
    },
    
    data: () => ({
        bscsInfo: { insDtDot: '', inspDay: '' },    // 기본정보
        inspRecDtlList: [],    // 구역별 일일 야간점검일지 목록
    }),
};
</script>